import "../styles/footer.css";
import logo from "../assets/images/logo.png";
import { Link as RouterLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-media">
          <img className="footer-media__image" src={logo} alt="logo" />
        </div>
        <div className="footer-rights">
          <span>all rights reserved &copy; Abdalla Saleh</span>
        </div>
        <div className="footer-links">
          <RouterLink to="/">home</RouterLink>
          <RouterLink to="/about">about</RouterLink>
          <RouterLink to="/contact">contact</RouterLink>
        </div>
      </div>
    </footer>
  );
}
